module.exports = __webpack_public_path__ + "static/img/BHKWI.2ec17b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AIR_BHKWI/BHKWI.jpg
// module id = gmLd
// module chunks = 0